import {createContext, useContext, useState, ReactNode} from "react"

interface ThreadDrawerContextType {
  selectedThread: string | null
  targetMessageId: string | null
  showThread: (threadId: string, messageId?: string) => void
  hideThread: () => void
}

const ThreadDrawerContext = createContext<ThreadDrawerContextType | null>(null)

export const ThreadDrawerProvider: React.FC<{children: ReactNode}> = ({
  children,
}) => {
  const [selectedThread, setSelectedThread] = useState<string | null>(null)
  const [targetMessageId, setTargetMessageId] = useState<string | null>(null)

  const showThread = (threadId: string, messageId?: string) => {
    setSelectedThread(threadId)
    setTargetMessageId(messageId || null)
  }

  const hideThread = () => {
    setSelectedThread(null)
    setTargetMessageId(null)
  }

  return (
    <ThreadDrawerContext.Provider
      value={{selectedThread, targetMessageId, showThread, hideThread}}
    >
      {children}
    </ThreadDrawerContext.Provider>
  )
}

export const useThreadDrawer = () => {
  const context = useContext(ThreadDrawerContext)
  if (!context) {
    throw new Error("useThreadDrawer must be used within ThreadDrawerProvider")
  }
  return context
}
